/* eslint-disable */


export const ProductType = 'RPDDOF';

export enum ProductPermissions {
  STOREMGMT = 'STOREMGMT',
  DELETE_DAP = 'RACPAD_DAP_DELETE',
  SUBMIT_DAP = 'RACPAD_DAP_SUBMIT',
  CANCEL_DAP = 'RACPAD_DAP_CANCEL',
  CREATE_GOAL = 'RACPAD_DAP_GOAL_CREATE',
  EDIT_GOAL = 'RACPAD_DAP_GOAL_EDIT',
  // Permission for create, edit and unblock
  // All users have view permission
  BLOCK_TIMESLOT = 'RACPAD_DAP_EVENT_BLOCK',
  SUPPORT_USER = 'RACPAD_DAP_SUPPORT',
  DAP_VIEW_ONLY_TASKS_EVENTS = 'DAP_VIEW_ONLY_TASKS_EVENTS'
}
export const level4customerSignModuleName = 'LevelFourEmailSignAccess'
export const RACPAD = 'RACPAD';

export const LOG_ACTIVITY_ERROR_MESSAGE =
  'Unable to log activity. Please try again later.';
export const API_ERROR_MESSAGE = 'Unable to fetch the data';

export const GRID_MOCK = {
  name: '-',
  refferedOn: '-',
  rewardEarned: '-',
  rewardUsedOn: '-',
  contactId: ''
};

export const SELECT_ONE_OPTION = '<Select One>';
export enum WORKED_HISTORY_CALL_RESULT_CODES {
  LMAL = 'LMAL',
  LMCE = 'LMCE',
  LMWK = 'LMWK',
  LMR1 = 'LMR1',
  LMR2 = 'LMR2',
  LMR3 = 'LMR3',
  LMR4 = 'LMR4',
  NO_ANSWER = 'NA',
  FIELD_VISIT = 'FIELD',
}
export const DATE_FORMAT = "MM/dd/yyyy";
export const STORE_NUMBER_KEY = 'storeNumber';
export enum CACHED_KEYS {
  TAKE_COMMITMENT_CACHED_KEY = 'commitment-cached-key',
  LOG_ACTIVITY_CACHED_KEY = 'log-activity-cached-key',
  FIELDVISITRESULT_CACHED_KEY = 'fieldvisitresult-cached-key',
  AM_ACTIVITY_LOG_SEARCH_KEY = 'am-activity-log-cached-key',
  PAST_DUE_SEARCH_KEY = 'past-due-list-cached-key',
  EDIT_CUSTOMER_INFORMATION_KEY = 'edit-customer-information-cached-key',
}

export enum WORKED_HISTORY_ACTIVITY_TYPE_CODES {
  CALL_CUSTOMER = 'CALLC',
  COMMITMENT = 'CMT',
  TEXT_SENT = 'TXTS',
  TEXT_RECEIVED = 'TXTR',
  CUST_SURVEY = 'CUSTSURV',
}

export const printLetterOptions = [
  { label: "None", value: "NONE" },    
  { label: "7 Days", value: "7" },
  { label: "14 Days", value: "14" },
];

export const createFVEventOptions = [
  { label: "Yes", value: "Y" },
  { label: "No", value: "N" },
];

export const enum DOCUMENT_TYPE {
  IDENTITY_DOC = 'IDENTTYDOC',
  EMPLOYMENT_DOC = 'EMPDOC',
  RESIDENCE_DOC = 'RESDOC'
}
const formatByNumeric = (input: string): string => {
  try {
    let onlyNumeric: string = input;
    if (input?.length) {
      return (onlyNumeric).replace(/\D/g, '');
    }
    return onlyNumeric;

  } catch (error: any) {
    console.log("Error in formatByNumeric: ", error?.message);
    return input;
  }
}
export const formatPhoneNumber = (input: string): string => {
  try {
    let phoneNumber: string = input;
    if (input && input.length > 0) {
      const cleaned = formatByNumeric(input); // Ensure this function is defined and works correctly

      // Match and format the phone number
      const match = cleaned.match(
        /^(?:\+?([0-9]{1,3})[-. ]?)?([0-9]{3})[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/
      );

      if (match) {
        const [, cc, area, prefix, line] = match;
        const allowedCodes = ['1', '52', '91'];

        if (!cc || allowedCodes.includes(cc)) {
          phoneNumber = `${cc ? '+' + cc + ' ' : ''}(${area}) ${prefix}-${line}`;
        } else {
          phoneNumber = cleaned; // Return as-is if not allowed
        }
      } else {
        phoneNumber = cleaned; // Fallback if not matched
      }
    }
    return phoneNumber;
  } catch (error: any) {
    console.log("Error in formatPhone: ", error?.message);
    return input;
  }
};